import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DisposizioneCompagnia } from '../models/disposizione-compagnia';
import { DisposizioneCompagniaAllegato } from '../models/disposizione-compagnia-allegato';
import { ResourcefulService } from './resourcefulService';

@Injectable({
  providedIn: 'root'
})
export class DisposizioneCompagniaService extends ResourcefulService<DisposizioneCompagnia> {
  constructor(private httpClient: HttpClient) {
    super(httpClient, DisposizioneCompagnia);
  }

  getAllegati(disposizioneId: number): Promise<DisposizioneCompagniaAllegato[]> {
    return this._httpClient
      .get<{ data: any[] }>(`${this.baseUrl}/disposizioni-compagnie/${disposizioneId}/allegati`)
      .toPromise()
      .then(response => response.data.map(item => new DisposizioneCompagniaAllegato().deserialize(item)));
  }

  uploadAllegato(disposizioneId: number, file: File): Observable<DisposizioneCompagniaAllegato> {
    const formData = new FormData();
    formData.append('file', file);
    return this._httpClient
      .post<any>(`${this.baseUrl}/disposizioni-compagnie/${disposizioneId}/allegati`, formData)
      .pipe(map(response => new DisposizioneCompagniaAllegato().deserialize(response?.data ?? response)));
  }

  deleteAllegato(disposizioneId: number, allegatoId: number): Promise<void> {
    return this._httpClient
      .delete<void>(`${this.baseUrl}/disposizioni-compagnie/${disposizioneId}/allegati/${allegatoId}`)
      .toPromise();
  }

  downloadAllegato(disposizioneId: number, allegatoId: number) {
    return this._httpClient.get(`${this.baseUrl}/disposizioni-compagnie/${disposizioneId}/allegati/${allegatoId}/download`, {
      responseType: 'blob',
      observe: 'response'
    }) as unknown as Observable<HttpResponse<Blob>>;
  }
}
